import { hasUrlParam } from 'utility/Provide/Url';

export const removeCsCodeFromUrl = () => {
    const hasCsCode = hasUrlParam('cs_code');
    if (hasCsCode) {
        const url = new URL(window.location.href);
        url.searchParams.delete('cs_code');
        window.history.replaceState({}, '', url.toString());
    }
};

export const addSemClasses = () => {
    const mainContent = document.querySelector('.c24-travel-main-cnt');
    const gridContainer = document.querySelector('.c24-grid-flex.form-content');

    if (mainContent && gridContainer) {
        mainContent.classList.add('c24-travel-main-cnt-promo-banner');
        gridContainer.classList.add('c24-travel-form-cnt-promo-banner');
    }
};
